import { MonetizationOn } from '@mui/icons-material';
import {
  InputAdornment,
  InputBaseComponentProps,
  TextField,
  TextFieldProps,
} from '@mui/material';
import { isNumber } from 'lodash';
import React, { RefObject } from 'react';
import { IMaskInput } from 'react-imask';

type MoneyMaskProps = InputBaseComponentProps & {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
};

const MoneyMask = React.forwardRef<HTMLElement, MoneyMaskProps>(
  (props, ref) => {
    const { onChange, value, ...other } = props;
    let newValue = value;
    if (isNumber(value)) {
      newValue = newValue.toFixed(2);
    }
    return (
      <IMaskInput
        {...other}
        mask="num"
        blocks={{
          num: {
            mask: Number,
            radix: '.',
            thousandsSeparator: ',',
            scale: 2,
            padFractionalZeros: true,
            normalizeZeros: true,
          },
        }}
        inputRef={ref as RefObject<HTMLInputElement>}
        onAccept={(value: string) =>
          onChange({
            target: { name: props.name, value },
          } as React.ChangeEvent<HTMLInputElement>)
        }
        value={newValue}
        unmask
        overwrite
      />
    );
  }
);

type MoneyFieldProps = Omit<TextFieldProps, 'inputComponent' | 'InputProps'> &
  MoneyMaskProps;

export const MoneyField: React.FC<MoneyFieldProps> = ({ unmask, ...props }) => {
  return (
    <TextField
      {...props}
      InputProps={{
        inputProps: { unmask },
        inputComponent: MoneyMask,
        startAdornment: (
          <InputAdornment position="start">
            <MonetizationOn fontSize="small" />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default MoneyField;
